import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {Http} from '@angular/http';
import {App, ToastController, Toast} from 'ionic-angular/index';
import {global, resetGlobal} from "../../environments/global";
import {MyAlertProvider} from "../my-alert/my-alert";
import * as data_json from "../../error-config/error-config.json"

/*
 Generated class for the HttpProvider provider.

 See https://angular.io/guide/dependency-injection for more info on providers
 and Angular DI.
 */
@Injectable()
export class HttpProvider {
  private base_path = global.base_url;
  private environment_path = global.env_url;

  //outman temp
  private easy_toggle: boolean = false;
  private token_toggle: boolean = true;

  constructor(public http: Http, private app: App, public myAlert: MyAlertProvider, public toastCtrl: ToastController) {
    // console.log('Hello HttpProvider Provider');
    // console.log(data_json)

    if ( this.token_toggle &&( window.location.href.indexOf('localhost') > -1 || window.location.href.indexOf('192.168') > -1 )) {
          // window.localStorage.setItem(global.token_name, "7e09a63699e709f9452618aa2120956e");
          window.localStorage.setItem(global.token_name, "8e65b1822f5a8e8419b1f500a79edd39");
          // window.localStorage.setItem(global.token_name, "78d9577287e3509636f690834975bee1");
        }
  }

  suffix = Math.random() * (2 ** 64);

  getVipIdentity(){
    if(!window.localStorage.getItem(global.token_name)){
      this.base_path = global.base_url;
    }else{
      this.http.post(global.base_url+'/user/get_identity',{'token':window.localStorage.getItem(global.token_name)}).map(res => res.json()).subscribe(res => {
        if(res['content']['vip']==0 || res['content']['vip']==1){
          this.base_path = global.base_url_c;
          console.log('如果出现了这行字说明生效了科科科')
        }
      })
    }

  }

  hPost(url, params?, timeout?): Observable<any> {
    let my_params = params ? params : {};
    let default_timeout = 10000;
    let real_timeout = timeout ? timeout : default_timeout;
    console.log(timeout);
    if (window.location.href.indexOf('localhost') > -1 && this.easy_toggle) {
        url =
          'https://www.easy-mock.com/mock/5ab8e67d3838ca14983dc1b9/yaca_api_v2' + url;
    } else {
      //outman temp
      url = this.base_path + this.environment_path + url;
    }

    url = url + "?suffix=" + this.suffix;

    if (window.localStorage.getItem(global.token_name)) {
      my_params.token = window.localStorage.getItem(global.token_name);
    }

    let myPost: Observable<any> = this.http
      .post(url, my_params)
      .timeoutWith(real_timeout, Observable.throw('Error timeout'))
      .map(res => res.json())
      .mergeMap(res => {
        if (res['err_code'] == 0) {
          return Observable.of(res);
        } else {
          return Observable.throw(res);
        }
      }).catch(res => {
        return this.errCatch(res);
      });

    return myPost;
  }

  verifyCode(code) {
    let myPost: Observable<any> = this.http
      .post(this.base_path + this.environment_path + '/login/wx_login', {
        code: code,
        app_name: global.app_name_real
      })
      .timeoutWith(10000, Observable.throw('Error timeout')).retry(2)
      .map(res => res.json())
      .mergeMap(res => {
        if (res['err_code'] == 0) {
          return Observable.of(res);
        } else {
          return Observable.throw(res);
        }
      });

    return myPost;
  }

  errCatch(err) {
    let result = Observable.throw(err);
    if (err == 'Error timeout') {
      let toast: Toast;

      if (!toast || !toast.isOverlay) {
        toast = this.toastCtrl.create({
          message: "加载超时，请重试...",
          duration: 3000
        });
        toast.present();

        result = Observable.throw("Error timeout");
      }
    }
    else if (err.err_name == "ERR_URL" ||
      err.err_name == "INFO_NO_USED_BOT" ||
      err.err_name == "ERR_DURATION_TIME_TOO_SHORT" ||
      err.err_name == "ERR_SMS_CODE_EXPIRED" ||
      err.err_name == "ERR_INVALID_SMS_CODE" ||
      err.err_name == "ERR_BATCH_SENDING_COUNT_LIMIT" ||
      err.err_name == "ERR_PHONE_WX" ||
      err.err_name == "ERR_NOT_ALLOWED_EXTENSION") {

    }
    else if (err.err_name == "ERR_USER_TOKEN_EXPIRED" || err.err_name == "ERR_USER_LOGIN_FAILED" || err.err_name == "ERR_USER_TOKEN") {
      this.app.getActiveNav().setRoot("ForbiddenPage");
    }
    else if (err.err_code > 20000 && err.err_code < 30000) {
      let alertObj = {
        type: "warning",
        title: "请求错误",
        message: data_json["err"][err.err_name].discription,
        success: {
          text: "知道了"
        }
      };
      this.myAlert.error_code = err.err_code;
      this.myAlert.showAlert(alertObj);
    }
    else {
      let alertObj = {
        type: "error",
        title: "哎哟，我们出了一点小问题，请稍后再试吧",
        success: {
          text: "知道了"
        }
      };
      this.myAlert.error_code = (err.err_code || err.status || 500);
      this.myAlert.showAlert(alertObj);
    }
    return result;

  }
}



// WEBPACK FOOTER //
// ./src/providers/http/http.ts